import { Link, Outlet } from 'react-router-dom';

import List from './List';
import CreateServiceForm from './forms/CreateService.form';
import UpdateServiceForm from './forms/UpdateService.form';

import Meta from "../../components/Meta";
import Header from "../../components/Header";

function Template() {
	return (
		<>
			<Meta title="Services" />
			<Header heading={"Services"} button={<Link to="create" className="btn btnPrimary">+ Create Service</Link>} />
			<main>
				<Outlet />
			</main>
		</>
	)
}

export default {
	Template,
	List,
	Create: CreateServiceForm,
	Update: UpdateServiceForm
};
